export const CYCLE_SHOW_TABS = ['general', 'delta_log'] as const;

export type CycleShowTab = (typeof CYCLE_SHOW_TABS)[number];

export const CYCLE_DEFAULT_TAB: CycleShowTab = 'general';
